import Vue from "vue";

export class CaixaConector {
    static create() {
        return {
            nome: null,
            place: [0, 0],
            obs: null
        };
    }

    /**
     *
     * @param id
     * @returns {Promise}
     */
    static byID(id) {
        return new Promise((resolve, reject) => {
            Vue.http
                .get("caixa-conector/" + id)
                .then(res => resolve(res.data), err => reject(err));
        });
    }

    /**
     *
     * @param id
     * @returns {Promise}
     */
    static excluir(id) {
        return new Promise((resolve, reject) => {
            Vue.http
                .delete("caixa-conector/" + id)
                .then(() => resolve(), err => reject(err));
        });
    }

    /**
     *
     * @return {Promise}
     */
    static all() {
        return new Promise((resolve, reject) => {
            Vue.http
                .get("caixas-conectores")
                .then(res => resolve(res.data), err => reject(err));
        });
    }

    /**
     *
     * @param data
     * @return {Promise}
     */
    static save(data) {
        return new Promise((resolve, reject) => {
            let promisse = null;

            if (data._id) {
                promisse = Vue.http.put("caixa-conector/" + data._id, data);
            } else {
                promisse = Vue.http.post("caixa-conector/0", data);
            }

            promisse.then(() => resolve(), err => reject(err));
        });
    }
}
